<template>
  <div id="onBoarding">
    <modal width="840px" height="603px" name="onboarding-modal">
      <b-carousel
        id="carousel-onboarding"
        ref="myCarousel"
        v-model="slide"
        :interval="0"
        indicators
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide img-height="840px" style="height: 603px">
          <div class="slide-container">
            <div class="slide-top">
              <div class="welcome">
                <h3>Welcome!</h3>
                <p>Get started and experience how TorchMetrics is fun and easy to use</p>
              </div>
              <div class="top-button-container">
                <a class="skip" @click="hide()">SKIP</a>
              </div>
            </div>
            <div class="slide-content">
              <h2>Create Presentation Survey</h2>
              <div class="content-info">
                <div class="content-text">
                  <h4><font-awesome-icon icon="chevron-right" />Select survey & send out!</h4>
                  <p>You can see the questions</p>
                  <h4><font-awesome-icon icon="chevron-right" />People take survey</h4>
                  <p>Get an email when a survey has been filled out</p>
                </div>
                <div class="img-container">
                  <img
                    class="img-fluid"
                    src="../../../public/img/onboarding/slide1-survey.png"
                  />
                </div>
              </div>
            </div>
            <div class="slide-btn">
              <TMGeneralButton
                text="NEXT"
                className="blue"
                @click.native="next()"
              />
            </div>
          </div>
        </b-carousel-slide>
        <b-carousel-slide img-height="840px" style="height: 603px">
          <div class="slide-container">
            <div class="slide-top">
              <div class="welcome">
                <h3>Welcome!</h3>
                <p>You are better than you think which you will see when you look at the results</p>
              </div>
              <div class="top-button-container">
                <a class="skip" @click="hide()">SKIP</a>
              </div>
            </div>
            <div class="slide-content">
              <h2>See Results</h2>
              <div class="content-info">
                <div class="content-text">
                  <h4><font-awesome-icon icon="chevron-right" />Your score is the average for that question</h4>
                  <p>Based on your score, TorchMetrics prioritizes which questions you need to focus on first</p>
                </div>
                <div class="img-container slide2-img-container">
                  <img
                    class="img-fluid"
                    src="../../../public/img/onboarding/slide2-screen.png"
                  />
                </div>
                <div class="slide2-img-composite">
                  <img
                  id="slide2-percent-img"
                  src="../../../public/img/onboarding/slide2-percent.png"
                  />
                  <span>Amazingly done!</span>
                </div>
              </div>
            </div>
            <div class="slide-btn">
              <TMGeneralButton
                text="NEXT"
                className="blue"
                @click.native="next()"
              />
            </div>
          </div>
        </b-carousel-slide>
        <b-carousel-slide img-height="840px" style="height: 603px">
          <div class="slide-container">
            <div class="slide-top">
              <div class="welcome">
                <h3>Welcome!</h3>
                <p>Easy-to-use action steps designed just for you so you can improve</p>
              </div>
              <div class="top-button-container">
                <a class="skip" @click="hide()">SKIP</a>
              </div>
            </div>
            <div class="slide-content">
              <h2>Complete Action Steps</h2>
              <div class="content-info">
                <div class="content-text">
                  <h4>
                    <font-awesome-icon icon="chevron-right" />Every 
                    survey question offers you three specific actions to improve  
                  </h4>
                  <p>
                    Checklists, before and after examples, questions for your listeners, 
                    resources and quick audio tips.
                  </p>
                </div>
                <div class="img-container">
                  <img
                    class="img-fluid"
                    src="../../../public/img/onboarding/slide3-action-steps.png"
                  />
                </div>
              </div>
            </div>
            <div class="slide-btn">
              <TMGeneralButton
                text="NEXT"
                className="blue"
                @click.native="next()"
              />
            </div>
          </div>
        </b-carousel-slide>
        <b-carousel-slide img-height="840px" style="height: 603px">
          <div class="slide-container">
            <div class="slide-top">
              <div class="welcome">
                <h3>Welcome!</h3>
                <p>Get even more motivated by tracking your progress</p>
              </div>
              <div class="top-button-container">
                <a class="skip" @click="hide()">SKIP</a>
              </div>
            </div>
            <div class="slide-content">
              <h2>Track Your Progress</h2>
              <div class="content-info">
                <div class="content-text slide4-content-text">
                  <h4>
                    <font-awesome-icon icon="chevron-right" />See how 
                    completing the action steps helped you improve
                  </h4>
                  <p>
                    Your dashboard shows your improvement over time in the four key skills
                  </p>
                </div>
                <div class="img-container">
                  <img
                    class="img-fluid"
                    src="../../../public/img/onboarding/slide4-track.png"
                  />
                </div>
                <div class="slide-4-img-container">
                  <img
                    class="img-fluid"
                    src="../../../public/img/onboarding/slide4-progress.png"
                  />
                </div>
              </div>
            </div>
            <div class="slide-btn">
              <TMGeneralButton
                text="NEXT"
                className="blue"
                @click.native="next()"
              />
            </div>
          </div>
        </b-carousel-slide>
        <b-carousel-slide img-height="840px" style="height: 603px">
          <div class="slide-container">
            <div class="slide-top">
              <div class="welcome">
                <h3>Welcome!</h3>
                <p></p>
              </div>
              <div class="top-button-container">
                <a class="close" @click="hide()">
                  <b-icon icon="x" />
                </a>              
              </div>
            </div>
            <div class="slide-content slide5-content">
              <div>
                <p>Now get going!</p>
                <p>Choose a survey, send it out and wait for the results.</p>
              </div>
            </div>
            <div>
              <TMGeneralButton text="CHOOSE A SURVEY" route="NewUserPresentation" className="blue" />
            </div>
          </div>
        </b-carousel-slide>
      </b-carousel>
    </modal>
  </div>
</template>

<script>
import TMGeneralButton from "../common/TMGeneralButton.vue";
import { mapActions, mapState } from "vuex";
export default {
  components: { TMGeneralButton },
  name: "onBoarding",
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  computed: {
    ...mapState(["currentUser"]),
  },

  methods: {
    ...mapActions(["UPDATE_ONBOARDING"]),
    show() {
      this.$modal.show("onboarding-modal");
    },
    hide() {
      this.$modal.hide("onboarding-modal");
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    next() {
      this.$refs.myCarousel.next();
    },
  },
  mounted() {
    if (!this.currentUser.onboarding) {
      this.show();
      this.UPDATE_ONBOARDING();
    }
  },
};
</script>
<style lang="less">
@import "../../assets/components/onBoarding/onBoarding.less";
</style>
